import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  fetchAccountsInfo as fetchAccountsInfoAPI,
  createAccountsInfo as createAccountsInfoAPI,
  updateAccountsInfo as updateAccountsInfoAPI,
  deleteAccountsInfo as deleteAccountsInfoAPI,
} from './api';
import {
  GetAccountsInfo,
  PutAccountsInfo,
  PostAccountsInfo,
  Status,
} from '../../services/apiTypes';
import { isGetAccountsInfo } from '../../_utils/typeGuardUtils';

interface accountsInfoState {
  status: Status;
  accountsInfoData: GetAccountsInfo;
}

const initialGetAccountsInfo: GetAccountsInfo = {
  marketCodeList: [],
  companyList: [],
};

const initialState: accountsInfoState = {
  status: 'idle',
  accountsInfoData: initialGetAccountsInfo,
};

export const fetchAccountsInfo = createAsyncThunk(
  'accountsInfo/fetchAccountsInfoData',
  async (_, { rejectWithValue }) => {
    try {
      return await fetchAccountsInfoAPI();
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const createAccountsInfo = createAsyncThunk(
  'user/createUser',
  async (targetAccountsInfo: PostAccountsInfo, { rejectWithValue }) => {
    try {
      return await createAccountsInfoAPI(targetAccountsInfo);
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const updateAccountsInfo = createAsyncThunk(
  'user/updateUser',
  async (targetAccountsInfo: PutAccountsInfo, { rejectWithValue }) => {
    try {
      return await updateAccountsInfoAPI(targetAccountsInfo);
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const deleteAccountsInfo = createAsyncThunk(
  'user/deleteUser',
  async (accountsInfoKey: string, { rejectWithValue }) => {
    try {
      return await deleteAccountsInfoAPI(accountsInfoKey);
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

const AccountsInfoDataSlice = createSlice({
  name: 'accountsInfoData',
  initialState,
  reducers: {
    resetAccountInfo: (state) => {
      state.accountsInfoData = initialGetAccountsInfo;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAccountsInfo.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchAccountsInfo.fulfilled, (state, action) => {
        state.status = 'succeeded';
        if (isGetAccountsInfo(action.payload)) {
          state.accountsInfoData = action.payload;
        }
      })
      .addCase(fetchAccountsInfo.rejected, (state) => {
        state.status = 'failed';
      })

      .addCase(createAccountsInfo.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(createAccountsInfo.fulfilled, (state) => {
        state.status = 'succeeded';
      })
      .addCase(createAccountsInfo.rejected, (state) => {
        state.status = 'failed';
      })
      .addCase(updateAccountsInfo.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(updateAccountsInfo.fulfilled, (state) => {
        state.status = 'succeeded';
      })
      .addCase(updateAccountsInfo.rejected, (state) => {
        state.status = 'failed';
      })
      .addCase(deleteAccountsInfo.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(deleteAccountsInfo.fulfilled, (state) => {
        state.status = 'succeeded';
      })
      .addCase(deleteAccountsInfo.rejected, (state) => {
        state.status = 'failed';
      });
  },
});

export const { resetAccountInfo } = AccountsInfoDataSlice.actions;
export default AccountsInfoDataSlice.reducer;
